import React from 'react';
import { Container } from 'react-bootstrap';

const LiveStreamsLandingSection = () => {
    return (
        <Container fluid className="py-5 bg-light">
            <h1 className="text-center fw-bold">Live Streams</h1>
            <p className="text-center my-0 mt-4">
                ChurchCamLive.ie provides live streaming services,
                audio installation,
            </p>
            <p className="text-center my-0">
                and network infrastructure solutions to churches, cathedrals,
                parish homes, and funeral homes.
            </p>
            <p></p>
        </Container>
    );
}

export default LiveStreamsLandingSection;